"use client";

import Image from "next/image";
import Link from "next/link";
import { ChevronLeft } from "lucide-react";
import { BackgroundAllProducts } from "@/components/shared/svg/Icons";


interface AuthLayoutProps {
    children: React.ReactNode;
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
    return (
        <div className="relative min-h-screen flex items-center justify-center px-4 bg-primary-50">
            {/* Background Pattern */}
            <BackgroundAllProducts className="absolute inset-0 pointer-events-none" />

            {/* Card */}
            <div className="relative z-10 w-full max-w-md bg-white rounded-2xl shadow-xl p-8 sm:p-10">
                {/* Back Link */}
                <Link 
                    href="/" 
                    className="absolute -top-12 left-0 flex items-center gap-2 text-primary-600 hover:text-primary-800 transition-colors font-medium"
                >
                    <ChevronLeft className="h-5 w-5" />
                    Retour vers le site
                </Link>

                <div className="flex justify-center mb-6">
                    <Image src="/assets/logo/logo.png" alt="Logo" width={80} height={80} />
                </div>

                <h2 className="text-center font-brastika text-2xl mb-8 text-primary-900">
                    Bienvenue chez Elzahraoui Store
                </h2>

                {children}
            </div>
        </div>
    );
};
